import { type FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StratMapCanvas from '@/components/canvas/StratMapCanvas';
import MobileCanvas from '@/components/canvas/mobile/MobileCanvas';
import canvasesApi from '@/api/canvases.api';
import useIsMobile from '@/hooks/useIsMobile';

export const CanvasPage: FC = () => {
  const { canvasId } = useParams<{ canvasId: string }>();
  const [workspaceId, setWorkspaceId] = useState<string>('');
  const isMobile = useIsMobile();

  useEffect(() => {
    if (canvasId) {
      canvasesApi.getById(canvasId).then((canvas) => {
        setWorkspaceId(canvas.workspaceId);
      });
    }
  }, [canvasId]);

  if (!canvasId) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          color: 'var(--color-text-muted)',
        }}
      >
        Aucun canvas sélectionné
      </div>
    );
  }

  if (isMobile) {
    return (
      <div
        className="canvas-fullbleed"
        style={{ height: 'calc(100vh - var(--header-height))', width: '100%' }}
      >
        <MobileCanvas canvasId={canvasId} workspaceId={workspaceId} />
      </div>
    );
  }

  return (
    <div
      className="canvas-fullbleed"
      style={{ height: 'calc(100vh - var(--header-height))', width: '100%' }}
    >
      <StratMapCanvas canvasId={canvasId} workspaceId={workspaceId} />
    </div>
  );
};

export default CanvasPage;
